export const AUTH_COOKIES = {
    DWSID_TOKEN: 'dwsid',
    ACCESS_TOKEN: 'accessToken',
    LAST_ACTIVE: 'lastActive',
    PETM_ANONYMOUS_KEY: 'petmAnonymousKey',
    PETM_CUSTOMER_KEY: 'petmCustomerKey',
    RECAPTCHA_IS_CHECKBOX: 'rcIsCbx',
    RECAPTCHA_TOKEN: 'rcToken',
    RECAPTCHA_TOKEN_CHECKBOX: 'rcTokenCbx',
    REFRESH_TOKEN: 'refreshToken',
    RESET_PW_EMAIL: 'resetPwEmail',
    TOKEN_EXPIRY: 'tokenExpiry',
    REMEMBER_ME: 'rememberMe',
    IS_ACCESS_TOKEN_AUTH0: 'isAccessTokenAuth0',
};

export const COOKIES = {
    CART_ID: 'ctCartId',
    ORDER_ID: 'orderId',
    KOUNT_ID: 'kountId',
    STORE_ID: 'StoreCookie',
    IS_SHIPPING_OPTION_CONFIRMED: 'isShippingOptionConfirmed',
    X_PETM_CHANNEL: 'x-petm-channel',
    X_PETM_DECISIONS: 'x-petm-decisions',
    X_PETM_GUEST_TOKEN: 'x-petm-guest-token',
    X_PETM_VISITOR_ID: 'x-petm-visitor-id',
    EMAIL_OPTIONAL_IN: 'emailOptionalIn',
};

export const OKTA_COOKIES = {
    OKTA_ACCESS_TOKEN: 'oktaAccessToken',
    OKTA_TOKEN_TYPE: 'oktaTokenType',
    OCTA_SCOPE: 'oktaScope',
    OKTA_REFRESH_TOKEN: 'oktaRefreshToken',
    OKTA_ID_TOKEN: 'oktaIdToken',
};

export const OG_COOKIE = 'og_auth';
